import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  LOCALE_ID,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core'
import { LocalChannel } from '../../interfaces/local-channel'
import { ChannelService } from '../../services/channel.service'
import { ChannelPosition } from '../channel/channel-position'
import { ChannelProgressComponent } from '../../layout/components/channel-progress/channel-progress.component'
import { CommonModule } from '@angular/common'
import { TranslateModule } from '@ngx-translate/core'
import moment from 'moment'
import { MomentPipe } from '../../pipes/moment.pipe'
import { HeaderComponent } from '../../layout/components/header/header.component'
import { ChannelPlayerComponent } from '../../layout/components/channel-player/channel-player.component'
import { LogService } from 'htv-lib'
import { HTVPlatform } from '../../platforms/platform'
import { PlatformService } from '../../platforms/platform.service'

@Component({
  selector: 'app-legacy-channel-grid',
  standalone: true,
  imports: [
    CommonModule,
    ChannelProgressComponent,
    HeaderComponent,
    MomentPipe,
    TranslateModule,
    ChannelPlayerComponent,
  ],
  templateUrl: './legacy-channel-grid.component.html',
  styleUrls: ['./legacy-channel-grid.component.scss'],
  providers: [{ provide: LOCALE_ID, useFactory: () => moment.locale() }],
})
export class LegacyChannelGridComponent implements OnInit, OnDestroy, AfterViewInit {
  channels!: LocalChannel[]
  selectedChannel?: LocalChannel

  platformType!: HTVPlatform
  HTVPlatform = HTVPlatform

  private mutationObserver?: MutationObserver

  @ViewChild('channelPlayer') channelPlayer!: ElementRef

  constructor(
    private channelService: ChannelService,
    public logService: LogService,
    private chRef: ChangeDetectorRef,
    private el: ElementRef,
    private platformService: PlatformService
  ) {
    // do nothing
  }

  ngOnInit(): void {
    this.logService.debug('In Legacy Grid')
    this.platformType = this.platformService.type
    this.channels = this.channelService.channels
  }

  ngAfterViewInit(): void {
    // This works, but seems unnecessary
    if (this.platformType == HTVPlatform.PHILIPS) {
      this.mutationObserver = new MutationObserver(() => {
        const selectedCard = this.el.nativeElement.querySelector('.channel-card.htv-selected')
        if (selectedCard) {
          const allChannelCards = Array.from(this.el.nativeElement.querySelectorAll('.channel-card.htv-selectable'))
          const index = allChannelCards.indexOf(selectedCard)
          if (index !== -1 && this.channels[index]) {
            this.focusChannel(this.channels[index])
          }
        }
      })

      this.mutationObserver.observe(this.el.nativeElement, {
        subtree: true,
        attributeFilter: ['class'],
      })
    }
  }

  ngOnDestroy(): void {
    this.channelService.stopChannel()
    this.mutationObserver?.disconnect()
  }

  // Use a timeout to avoid waiting for loadChannel process to redraw the view
  // Display is much more nice to see
  focusChannel(channel: LocalChannel): void {
    if (this.selectedChannel?.id === channel.id && this.platformType == HTVPlatform.PHILIPS) return
    this.selectedChannel = channel
    this.chRef.detectChanges()
    setTimeout(() => {
      this.loadChannel()
    }, 10)
  }

  loadChannel(): void {
    if (this.selectedChannel) {
      const boundingRect: DOMRect = this.channelPlayer.nativeElement.getBoundingClientRect()
      const pos: ChannelPosition = {
        left: boundingRect.left,
        top: boundingRect.top,
        width: boundingRect.width,
        height: boundingRect.height,
      }
      this.channelService.startChannel(this.selectedChannel, pos)
    }
  }

  openChannelPage(): void {
    if (this.selectedChannel) {
      this.channelService.openChannelPage(this.selectedChannel)
    }
  }
}
